// Constants
import MIME_TYPE from 'tbase/constants/ExtensionVsMIME';

export const IMAGE_FILE_TYPES = `${MIME_TYPE.jpg}, ${MIME_TYPE.jpeg}, ${MIME_TYPE.png}`;

export const EXCEL_FILE_TYPES = `${MIME_TYPE.xls}, ${MIME_TYPE.xlsx}`;
